<template>
  <div
    id="tenant-submission-comments"
    class="commment-wrapper"
  >
    <template>
      <div
        v-if="hasPendingSubmission"
        class="batch-label"
      >{{ $t('tenantProjects.tenantViewComments.batchNumber', [currentTenantSubmission ? (currentTenantSubmission.order + 1) : 1]) }}</div>
      <DesignComment
        v-if="!isReinstatementPoject"
        ref="designComments"
        :canComment="canCommentDesign"
      />
      <hr
        v-if="!isReinstatementPoject"
        align="center"
      >
      <TechComments ref="techComments" />
      <div
        class="file-attachments"
        v-show="isReviewer || files.length > 0"
      >
        <HkldDropzone
          v-if="isReviewer"
          :sourceId="((canCommentDesign || canCommentTech) && currentTenantSubmission && currentTenantSubmission.id) || ''"
        />
        <TenantSubmissionDocuments
          v-if="activeSubmission"
          :files.sync="files"
          :canEdit="isReviewer"
          :sourceId="(currentTenantSubmission && currentTenantSubmission.id) || ''"
        />
      </div>
    </template>
    <CommentsView />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import HkldDropzone from '@/controls/HkldDropzone'
import CommentsView from '@/modules/tenantProjects/CommentsView'
import DesignComment from './DesignComment'
import TechComments from './TechComments'
import TenantSubmissionDocuments from './TenantSubmissionDocuments'

import { tenantProjectTypes } from '@/utils/locale'

export default {
  name: 'SubmissionsComments',
  components: {
    DesignComment,
    TechComments,
    HkldDropzone,
    TenantSubmissionDocuments,
    CommentsView,
  },
  props: {
    canCommentDesign: Boolean,
    canCommentTech: Boolean,
    isTenant: Boolean,
  },
  data () {
    return {
      files: [],
      tenantProjectTypes,
    }
  },
  computed: {
    ...mapGetters('tenantProject', ['currentTenantProject', 'activeSubmission', 'currentTenantSubmission', 'hasPendingSubmission']),
    ...mapGetters('user', ['currentUser']),
    comments () {
      return deep(this.activeSubmission, 'techComment.comments') || []
    },
    isReviewer () {
      return this.hasPendingSubmission && ([this.currentTenantSubmission.designManagedBy, this.currentTenantSubmission.techManagedBy].includes(this.currentUser.id))
    },
    isReinstatementPoject () {
      return this.currentTenantProject.type === tenantProjectTypes.Reinstatement
    },
  },
}
</script>

<style lang="scss" scoped>
.commment-wrapper {
  background-color: white
}
.file-attachments {
  opacity: 0.9;
  border: solid 1px #e5e9eb;
  padding: 10px 15px 0px 15px;
  margin: 10px;
}
.batch-label {
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  margin: 16px 0 0 0;
}
hr {
  border: solid 1px #5d7c9d;
  opacity: 0.21;
  max-width: calc(100% - 24px);
  margin:0 auto;
}
</style>
